import React, { useState } from "react";
import { Row, Col, Card, Button, Input, message } from "antd";
import { Modal } from "semantic-ui-react";
import axios from "axios";
import QRCode from "react-qr-code";

const Setup = () => {
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [method, setMethod] = useState(null);
  const [isSetupModalVisible, setIsSetupModalVisible] = useState(false);
  const [qrCode, setQrCode] = useState(null);
  const [code, setCode] = useState("");

  const handle2FASetup = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `https://api.intensel.net/api/user/configure_multifactor/${method}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      message.success("2FA code generated successfully");

      if (method === "app") {
        setQrCode(response.data.uri); // Assume QR code comes as qr_code
      }

      setIsSetupModalVisible(true);
    } catch (err) {
      message.error("Failed to generate 2FA setup. Try again.");
    }
  };

  const showConfirmation = (selectedMethod) => {
    setMethod(selectedMethod);
    setIsConfirmModalVisible(true);
  };

  const handleContinue = () => {
    setIsConfirmModalVisible(false);
    handle2FASetup();
  };

  const handleVerify = async () => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("code", code);

      const response = await axios.post(
        `https://api.intensel.net/api/user/configure_multifactor/${method}/`,
        formData,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      // Show success for 5 seconds, then redirect
      message.success("2FA verification successful", 5, () => {
        window.location.href = "/location"; // redirect after message closes
      });

      setIsSetupModalVisible(false);
      setIsConfirmModalVisible(false);
    } catch (err) {
      message.error("Invalid verification code. Please try again.", 5);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Row gutter={24} style={{ width: "90%" }}>
        <Col span={24}>
          <Card title="Two-Factor Authentication Setup">
            <p>
              Setting up two-factor authentication adds an extra layer of
              security to your account. Choose one of the methods below to
              enhance your account security.
            </p>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="App-Based Authentication">
            <p>
              Use an authenticator app like Google Authenticator or Microsoft
              Authenticator to generate verification codes. This method works
              even without internet access.
              <br />
              <i>
                <br />
                If you have already set up a 2FA on your authentication app for
                Intensel you will need to remove the old authentication. In your
                app click on Intensel and find the setup, usually a cog, click
                on that and remove. This will remove Intensel from the
                authenticator app. Then you can follow the instructions.
              </i>
            </p>
            <br />
            <Button
              className="custom-dark-button"
              type="primary"
              onClick={() => showConfirmation("app")}
            >
              Setup App-Based 2FA
            </Button>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Email-Based Authentication">
            <p>
              Receive verification codes via email when logging in. Convenient
              if you don’t want to use an authenticator app but still need
              enhanced security.
              <br />
              <i style={{ color: "black" }}>
                <br />
                Check your spam/junk folder too.
              </i>
            </p>
            <Button
              className="custom-dark-button"
              type="primary"
              onClick={() => showConfirmation("email")}
            >
              Setup Email-Based 2FA
            </Button>
          </Card>
        </Col>
      </Row>

      {/* Semantic UI Confirm Modal */}
      <Modal
        open={isConfirmModalVisible}
        size="small"
        onClose={() => setIsConfirmModalVisible(false)}
      >
        <Modal.Header>
          Setup {method === "app" ? "App-Based" : "Email-Based"} Authentication
        </Modal.Header>
        <Modal.Content>
          <p>
            Warning: This will override any existing 2FA setup. Do you want to
            continue?
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="custom-dark-button"
            onClick={() => setIsConfirmModalVisible(false)}
          >
            Cancel
          </Button>
          <Button
            className="custom-dark-button"
            type="primary"
            onClick={handleContinue}
            style={{ marginLeft: "1%" }}
          >
            Continue
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Semantic UI Setup Modal */}
      <Modal
        open={isSetupModalVisible}
        size="small"
        onClose={() => setIsSetupModalVisible(false)}
      >
        <Modal.Header>
          {method === "app" ? "Scan QR Code" : "Verify Email Code"}
        </Modal.Header>
        <Modal.Content>
          {method === "app" ? (
            <>
              <p>
                Scan this QR code with your authenticator app, then enter the
                6-digit code below.
              </p>
              <div style={{ textAlign: "center" }}>
                {qrCode && (
                  <QRCode
                    value={qrCode}
                    style={{ height: "200px", width: "200px" }}
                  />
                )}
              </div>
              <br />
              <Input
                placeholder="Enter the 6-digit code from your app"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </>
          ) : (
            <>
              <p>
                Enter the verification code that was sent to your email address.
              </p>
              <Input
                placeholder="Enter the 6-digit code from your email"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="custom-dark-button"
            type="primary"
            onClick={handleVerify}
          >
            Verify Setup
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default Setup;
